import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {getCreditCardsSelector as getCrediCardsSelector} from "./PaymentCardsSelectors";
import PaymentTypeDetails from "./PaymentTypeDetails";

export class CreditCardsList extends Component {
  
  render() {
    return <div>{
      this.props.cards.map((card, index) => {
        return <div key={card.payment_card_token}><PaymentTypeDetails payment_card={card} onEdit={this.props.onEdit} onDelete={this.props.onDelete}/></div>
      })
    }{
      this.props.cards.length === 0 && <span>No cards associated with this account.</span>
    }</div>
  }
}

CreditCardsList.propTypes = {
  cards: PropTypes.array,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default connect((state, props) => {
  return {
    cards: getCrediCardsSelector(state, props),
  }
})(CreditCardsList);
